"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRequestEmailChangeDto = instanceOfRequestEmailChangeDto;
exports.RequestEmailChangeDtoFromJSON = RequestEmailChangeDtoFromJSON;
exports.RequestEmailChangeDtoFromJSONTyped = RequestEmailChangeDtoFromJSONTyped;
exports.RequestEmailChangeDtoToJSON = RequestEmailChangeDtoToJSON;
exports.RequestEmailChangeDtoToJSONTyped = RequestEmailChangeDtoToJSONTyped;
/**
 * Check if a given object implements the RequestEmailChangeDto interface.
 */
function instanceOfRequestEmailChangeDto(value) {
    if (!('newEmail' in value) || value['newEmail'] === undefined)
        return false;
    return true;
}
function RequestEmailChangeDtoFromJSON(json) {
    return RequestEmailChangeDtoFromJSONTyped(json, false);
}
function RequestEmailChangeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'newEmail': json['newEmail'],
    };
}
function RequestEmailChangeDtoToJSON(json) {
    return RequestEmailChangeDtoToJSONTyped(json, false);
}
function RequestEmailChangeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'newEmail': value['newEmail'],
    };
}
